/* HistoryViewRenderer.js */

"use strict";
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const BaseActivityViewRender = require("../../../../lib/activity/BaseActivityViewRender");
const Registrations = require("../../../../../RegistrationNamespaces");

class HistoryViewRenderer extends BaseActivityViewRender {
    constructor(model) {
        super(model);
        this._rootElem = document.createElement("audit-history-view-gl");
        this._rootElem.component = this._model;

        this._summarySection = document.createElement("div");
        this._summarySection.classList.add("summary-section");

        this._gridSection = document.createElement("div");
        this._gridSection.classList.add("grid-section");
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerHistoryListeners() {}

    _unregisterHistoryListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        return super.shutdown().then(
            () => {
                this._summarySection.remove();
                this._summarySection = undefined;
                this._gridSection.remove();
                this._gridSection = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "HistoryViewRenderer.shutdown() error.");
            }
        );
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    render() {
        return this._model.whenModelIsReady().then(() => {
            this._renderSummary(this._model._gameEditor.getAuditPolicy());
            this._renderGrid();

            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._summarySection);
                this._rootElem.appendChild(this._gridSection);
            }
            this._registerListeners();
            this._renderGridRows();
            this._hideDownloadViewAction();
        });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onGridUserRowDoubleClicked(row) {
        const resultsView = Registrations.AUDIT_POLICY_EDITOR_VIEW_RESULTS;

        const executionEntity = this._model._activityFeed.getEntityById(row.selectedRow);

        if (executionEntity) {
            this._model._gameEditor.setActiveView(
                resultsView,
                [
                    {
                        value: {
                            fqn: Registrations.AUDIT_POLICY_EDITOR_VIEW_HISTORY,
                            viewState: { configExecutionEntity: executionEntity }
                        },
                        content: "Audit Execution Summary",
                        left: {
                            arrow: {
                                direction: "left"
                            }
                        }
                    }
                ],
                { configExecutionEntity: executionEntity, isSubView: true }
            );
        } else {
            this._model._logger.warn({}, "User clicked on viewResults in the Audit History View for a row that does not have a work.");
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _renderSummary(policy) {
        let summaryTemplate = _.template(`
            <div class="summary">
                <div class="summary-column">
                    <div class="summary-item"><span class="data-label">Policy Name</span><span class="data-value" title="Policy Name: <%=name ? name : '-'%>">
                    <%=name ? name : '-'%></span></div>
                    <div class="summary-item"><span class="data-label">Description</span><span class="data-value" title="Description: <%=description ? description : '-'%>">
                    <%=description ? description : '-'%></span></div>
                </div>
            </div>
        `);

        this._summarySection.innerHTML = summaryTemplate(policy);
    }

    _renderGrid() {
        const viewStateExecution = this.model.viewState.configExecutionEntity;

        this._gridSection.innerHTML = "";
        this._activityGrid = new EntityGrid({
            gridKey: this._model._gridKey,
            columns: this._model.columnConfig,
            pagingFeed: this._model._activityFeed,
            showHeader: true
        });

        this._gridSection.appendChild(this._activityGrid.renderer.rootElement);

        if (viewStateExecution) {
            this._activityGrid.renderer.renderPromise.then(() => {
                this._activityGrid.loadAndScrollTo(viewStateExecution.id);
            });
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = HistoryViewRenderer;
